


























































































































































































































































































































import { defineComponent, reactive, toRefs, computed, ref, onMounted, onBeforeUnmount } from '@vue/composition-api';
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import moment from 'moment';
import { BModal, BCarousel } from 'bootstrap-vue';
import AlertArea from "../../components/AlertArea.vue";
import { SumupUnitResult, SumupPart1Result, SumupFieldResult } from "../../modules/practice_examinee/ResultDetail"

export interface Data {
  sumup_unit_id: string
  sumup_group_name: string
  sumupUnitResult: SumupUnitResult
  sumupPart1Results: SumupPart1Result[]
  sumupFieldResults: SumupFieldResult[]
  sortPart1Asc: boolean
  sortTotalScoreRateAsc: boolean
  sortCorrectStateAsc: boolean
  errors: string[]
  is_exists_gender_result: boolean
  section: any
  total_column: any
  part1_column: any
  field_column: any
  total_result_col_count: number
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
  },
  setup(props, context){

    /************************************************************
     * data
     ************************************************************/

    const state = reactive<Data>({
      sumup_unit_id: null,
      sumup_group_name: null,
      sumupUnitResult: null,
      sumupPart1Results: [],
      sumupFieldResults: [],
      sortPart1Asc: true,
      sortTotalScoreRateAsc: true,
      sortCorrectStateAsc: true,
      errors: [],
      is_exists_gender_result: false,
      section: {},
      total_column: {},
      part1_column: {},
      field_column: {},
      total_result_col_count: 0,
    });

    /************************************************************
     * correct_state文字列に変換
     ************************************************************/

    const convertCorrectText = (correct_state: number) => {
      switch (correct_state) {
        case -1:
          return "×"
          break;
        case 1:
          return "○"
          break;
        case 0:
          return "△"
          break;
      }
    };

    // 大問1を並び替え
    const sortByPart1 = () => {
      if (state.sortPart1Asc) {
        // 昇順
        state.sumupFieldResults.sort(function(a, b) {
          if (a.part1 <= b.part1) {
            return 1;
          } else {
            return -1;
          }
        });
      } else {
        // 降順
        state.sumupFieldResults.sort(function(a, b) {
          if (a.part1 >= b.part1) {
            return 1;
          } else {
            return -1;
          }
        });
      }
      state.sortPart1Asc = !state.sortPart1Asc
    };

    // 全体正答率を並び替え
    const sortByTotalScoreRate = () => {
      if (state.sortTotalScoreRateAsc) {
        // 昇順
        state.sumupFieldResults.sort(function(a, b) {
          if (Number(a.total_score_rate) >= Number(b.total_score_rate)) {
            return 1;
          } else {
            return -1;
          }
        });
      } else {
        // 降順
        state.sumupFieldResults.sort(function(a, b) {
          if (Number(a.total_score_rate) <= Number(b.total_score_rate)) {
            return 1;
          } else {
            return -1;
          }
        });
      }
      state.sortTotalScoreRateAsc = !state.sortTotalScoreRateAsc
    };

    // 男女内正答率を並び替え
    const sortByGenderScoreRate = () => {
      if (state.sortTotalScoreRateAsc) {
        // 昇順
        state.sumupFieldResults.sort(function(a, b) {
          if (Number(a.gender_score_rate) >= Number(b.gender_score_rate)) {
            return 1;
          } else {
            return -1;
          }
        });
      } else {
        // 降順
        state.sumupFieldResults.sort(function(a, b) {
          if (Number(a.total_score_rate) <= Number(b.total_score_rate)) {
            return 1;
          } else {
            return -1;
          }
        });
      }
      state.sortTotalScoreRateAsc = !state.sortTotalScoreRateAsc
    };

    // 正誤を並び替え
    const sortByCorrectState = () => {
      if (state.sortCorrectStateAsc) {
        // 昇順
        state.sumupFieldResults.sort(function(a, b) {
          if (a.correct_state >= b.correct_state) {
            return 1;
          } else {
            return -1;
          }
        });
      } else {
        // 降順
        state.sumupFieldResults.sort(function(a, b) {
          if (a.correct_state <= b.correct_state) {
            return 1;
          } else {
            return -1;
          }
        });
      }
      state.sortCorrectStateAsc = !state.sortCorrectStateAsc
    };

    /************************************************************
     * 答案PDFダウンロード
     ************************************************************/

    const downloadPdf = async (sheet: any) => {
      context.root.$store.dispatch("showOverlay");

      await http.get(`/api/practice_examinee/result_detail/download_pdf?sumup_unit_id=${state.sumup_unit_id}&practice_examinee_id=${context.root.$store.state.practice_examinee_id}`, {responseType: 'arraybuffer'}).then(response => {
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const a = document.createElement('a');
        a.href = window.URL.createObjectURL(blob);
        a.target = "_blank"
        a.click();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    const toBlob = (base64: string, mime_ctype: string) => {
        // 日本語の文字化けに対処するためBOMを作成する。
        var bom = new Uint8Array([0xEF, 0xBB, 0xBF]);
 
        var bin = atob(base64.replace(/^.*,/, ''));
        var buffer = new Uint8Array(bin.length);
        for (var i = 0; i < bin.length; i++) {
            buffer[i] = bin.charCodeAt(i);
        }
        // Blobを作成
        try {
            var blob = new Blob([bom, buffer.buffer], {
                type: mime_ctype,
            });
        } catch (e) {
            return false;
        }
        return blob;
    }

    /************************************************************
     * mounted
     ************************************************************/

    onMounted(async () => {

      state.sumup_unit_id = context.root.$route.params.sumup_unit_id;

      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      await http.get(`/api/practice_examinee/result_detail?sumup_unit_id=${state.sumup_unit_id}&practice_examinee_id=${context.root.$store.state.practice_examinee_id}`).then(response => {
        state.sumup_group_name = response.data.sumup_group_name;
        state.sumupUnitResult = new SumupUnitResult(response.data.sumup_unit_result)
        state.sumupPart1Results = response.data.sumup_part1_results.map((x: any) => new SumupPart1Result(x));
        state.sumupFieldResults = response.data.sumup_field_results.map((x: any) => new SumupFieldResult(x));
        state.is_exists_gender_result = response.data.is_exists_gender_result;
        state.section = response.data.section;
        state.total_column = response.data.total_column;
        state.part1_column = response.data.part1_column;
        state.field_column = response.data.field_column;
        state.total_result_col_count = response.data.total_result_col_count;
      })
      .catch(error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          alert(`試験情報の取得処理に失敗しました。前の画面に戻ります。\n${error.response.data.errors[0]}`);
        }else{
          alert(`試験情報の取得処理に失敗しました。前の画面に戻ります。`);
        }
        window.history.back();
      });

      context.root.$store.dispatch("hideOverlay");
    });

    return {
      ...toRefs(state),
      convertCorrectText,
      sortByPart1,
      sortByTotalScoreRate,
      sortByGenderScoreRate,
      sortByCorrectState,
      downloadPdf,
    };
  }
})
